import { useState, useEffect, useMemo } from "react";
import { mockOrders } from "@/mocks/orders";
import type { Order } from "@/mocks/orders";

interface UseOrdersResult {
  orders: Order[];
  loading: boolean;
}

export function useOrders(): UseOrdersResult {
  const [localOrders, setLocalOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("generalstore_orders");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          setLocalOrders(parsed);
        }
      }
    } catch {
      // corrupted data
    }
    setLoading(false);
  }, []);

  const orders = useMemo(() => {
    // Merge local orders with mock orders, local first (newest)
    const merged = [...localOrders];
    const localIds = new Set(localOrders.map((o) => o.id));

    mockOrders.forEach((mockOrder) => {
      if (!localIds.has(mockOrder.id)) {
        merged.push(mockOrder);
      }
    });

    // Sort by date descending
    merged.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    return merged;
  }, [localOrders]);

  return { orders, loading };
}